import { Injectable } from '@angular/core';
import { ScaleRelativeToCenterComponent } from './ScaleRelativeToCenterComponent';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { Rectangle } from '../object3D';

declare let THREE: any;

@Injectable()
export class RectangleScaleComponent extends ScaleRelativeToCenterComponent<Rectangle> {

  constructor(
    drawings: DrawingsHolderService,
    positionCalculator: PositionCalculatorService
  ) {
    super(Rectangle, drawings, positionCalculator);
  }

  protected getNewSize(newSize, oldSize): any {
    const newWidth = Math.abs(newSize.x) * 2 || oldSize.x;
    const newHeight = Math.abs(newSize.z) * 2 || oldSize.z;
    return new THREE.Vector3(newWidth, 0, newHeight);
  }

  protected getObjectSize(object: Rectangle, result) {
    result.copy(object.getSize());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/RectangleScaleComponent.ts